import { CodedStatusMessage } from './coded-status-message.model';

export enum PlanCheckStatus {
  OK = 'OK',
  WARN = 'WARN',
  ERROR = 'ERROR',
  NOT_CHECKED = 'NOT_CHECKED'
}

/**
 * A plan-check finding. `blocksOptimization` is DataLayer's judgement that the solver
 * would fail or produce a meaningless result — not a severity. A trivially fixable
 * missing field can block; 80% of jobs being infeasible does not.
 */
export interface PlanFinding extends CodedStatusMessage {
  blocksOptimization: boolean;
}

export interface PlanFindingsResponse {
  findings: PlanFinding[];
  status: PlanCheckStatus;
  isStale: boolean;
}

/** A finding as it arrives, after the response interceptor has camel-cased its keys. */
export interface PlanFindingWire {
  errorCode?: string;
  errorMessage?: string;
  details?: object;
  blocksOptimization?: boolean;
}

export interface PlanFindingsWire {
  findings?: PlanFindingWire[];
  status?: PlanCheckStatus;
  isStale?: boolean;
}

export function findingFromWire(wire: PlanFindingWire): PlanFinding {
  return {
    errorCode: wire.errorCode ?? '',
    errorMessage: wire.errorMessage ?? '',
    details: wire.details,
    blocksOptimization: wire.blocksOptimization ?? false
  };
}

export function findingsFromWire(wire: PlanFindingsWire): PlanFindingsResponse {
  return {
    findings: (wire.findings ?? []).map(findingFromWire),
    status: wire.status ?? PlanCheckStatus.NOT_CHECKED,
    isStale: wire.isStale ?? false
  };
}
